import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AutoAttendantsFieldConfig } from '../../shared/models/generated/ziroModels';

@Injectable()
export class TeamsAutoAttendantsFieldConfigResource {
  private _httpClient = inject(HttpClient);

  get(tenantId: string): Observable<AutoAttendantsFieldConfig> {
    return this._httpClient.get<AutoAttendantsFieldConfig>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/field-configs`,
    );
  }
}
